import React from 'react';





const Payment = () => {
    return (
        <div className='my-3'>
            <h2 className='my-5 text-center font-extrabold text-3xl'> The Paymant system is comming soon ! </h2>
        </div>
    );
};

export default Payment;